// The personal side: how I work, what drives me, and life outside work.
// Working-style points come from the resume; "drives" and the quote come
// from the original portfolio's About page.

export const ABOUT = {
  intro:
    "I'm a problem solver at heart. I care about the people I build with as much as the people I build for, and I like work that leaves things better than I found them.",
  principles: [
    {
      title: "Start from the business problem",
      text: "I turn messy requirements and domain logic into systems people actually use, and I check that the result moved the number it was meant to move.",
    },
    {
      title: "Lift the people around me",
      text: "I've mentored junior engineers through code reviews, system design walkthroughs, and regular pair programming. Teams get faster when knowledge is shared.",
    },
    {
      title: "Build for everyone",
      text: "Accessibility isn't a final checklist for me. I audit for it and design components so they work for every user from the start.",
    },
    {
      title: "Ship with care",
      text: "I like strong tests, clear monitoring, and release checks, so a team can move quickly without being afraid of production.",
    },
    {
      title: "Plan across teams",
      text: "Good software crosses team lines. I enjoy joint technical planning and keeping shared delivery pipelines healthy.",
    },
  ],
  drives: ["Exploring new technologies", "Solving complex problems", "Learning and growing"],
  // Add hobbies here, e.g. "Hiking", "Photography". The section hides when empty.
  hobbies: [],
  quote: "Strive to build things that make a difference.",
};
